import React from 'react'
import styled from 'styled-components'

import FormSection from 'pages/shared/FormSection'

import Checkbox from 'components/Checkbox'
import TextInput from 'components/TextInput'

import { screenSize } from 'styles/shared'

import { scrubText } from 'helpers/inputCleaners'

type Props ={
    hideChart: boolean
    hideRanges: boolean
    showAlert: boolean
    showZeroWaterMark: boolean
    drawLines: boolean
    plotZero: boolean
    waterMark: string
    onChangeCallback: (options: Partial<Props>) => void
}
const ChartOptions = ({ hideChart, hideRanges, showAlert, showZeroWaterMark, drawLines, plotZero, waterMark, onChangeCallback }: Props) => {
  return (
    <FormSection title="Chart Options">
      <Checkbox
        label="Hide Chart, Colors, and Selections"
        checked={hideChart}
        onChange={() => onChangeCallback({ hideChart: !hideChart })}
      />
      <Checkbox
        label="Hide Recommended Ranges"
        checked={hideRanges}
        onChange={() => onChangeCallback({ hideRanges: !hideRanges })}
      />
      <Checkbox
        label="Show Watermark for all Zeros"
        checked={showZeroWaterMark}
        onChange={() => onChangeCallback({ showZeroWaterMark: !showZeroWaterMark })}
      />
      <Checkbox
        label="Always Show Alert Plotband"
        checked={showAlert}
        onChange={() => onChangeCallback({ showAlert: !showAlert })}
      />
      <Checkbox
        label="Plot 0"
        checked={plotZero}
        onChange={() => onChangeCallback({ plotZero: !plotZero })}
      />
      <Checkbox
        label="Draw Lines"
        checked={drawLines}
        onChange={() => onChangeCallback({ drawLines: !drawLines })}
      />
      <S.TextInput
        label="Watermark"
        onChange={event => onChangeCallback({ waterMark: scrubText(event.target.value, true) })}
        value={waterMark || ''}
      />
    </FormSection>
  )
}

export default ChartOptions

const S = {
  TextInput: styled(TextInput)`
    width: 50%;

    @media ${screenSize.small} {
      width: 100%;
    }
  `
}
